(() => {
  'use strict';
  const storageKey = 'hanvoran.inquiryAttribution.v1';
  const missing = 'Not provided (未提供)';
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const boundForms = new WeakSet();
  let record = null;
  let status = 'Not provided: consent not available';
  let storageAvailable = true;
  let revoked = false;
  const cleanText = value => typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 256) : '';
  function pageURL(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !['https:', 'http:'].includes(url.protocol) || url.username || url.password) return '';
      url.search = '';
      url.hash = '';
      return url.href.slice(0, 2048);
    } catch { return ''; }
  }
  const currentPage = pageURL(location.href);
  const internalReferrer = pageURL(document.referrer);
  function permission() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.marketingAllowed !== 'function') return null;
      return privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch { return null; }
  }
  function clearStored() {
    record = null;
    try { sessionStorage.removeItem(storageKey); } catch { storageAvailable = false; }
  }
  function readStored() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!saved || saved.version !== 1 || !saved.utm || typeof saved.utm !== 'object') return null;
      return {
        version: 1,
        landing: pageURL(saved.landing),
        utm: Object.fromEntries(utmKeys.map(key => [key, cleanText(saved.utm[key])]))
      };
    } catch { storageAvailable = false; return null; }
  }
  function refreshAttribution() {
    const consent = permission();
    if (consent !== true) {
      if (consent === false) {
        if (record) revoked = true;
        clearStored();
      } else record = null;
      status = 'Not provided: attribution consent unavailable or not allowed';
      return;
    }
    if (!record) record = readStored();
    if (!record) {
      const params = new URLSearchParams(location.search);
      const firstEntryKnown = !internalReferrer && !revoked;
      record = {
        version: 1,
        landing: firstEntryKnown ? currentPage : '',
        utm: Object.fromEntries(utmKeys.map(key => [key, firstEntryKnown ? cleanText(params.get(key)) : '']))
      };
    }
    try { sessionStorage.setItem(storageKey, JSON.stringify(record)); } catch { storageAvailable = false; }
    status = record.landing ? 'First entry in this tab session; URL query and fragment omitted' : 'First entry unavailable; no original source inferred';
    if (!storageAvailable) status += '; browser storage unavailable, cross-page retention not guaranteed';
  }
  function sourcePage(form) {
    const params = new URLSearchParams(location.search);
    const values = [
      form.querySelector('[data-inquiry-url]')?.value,
      form.querySelector('[data-inquiry-source-url]')?.value,
      params.get('product_url'),
      params.get('source_url')
    ];
    for (const value of values) {
      const url = pageURL(value);
      if (url) return url;
    }
    return location.pathname.includes('/pages/contact') ? internalReferrer || currentPage : currentPage;
  }
  function setField(form, label, value) {
    const name = 'contact[' + label + ']';
    let input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-hanvoran-attribution', 'true');
      form.appendChild(input);
    }
    input.value = value || missing;
  }
  function fill(form) {
    setField(form, 'Inquiry source page', sourcePage(form));
    setField(form, 'Inquiry form page', currentPage);
    setField(form, 'First landing page', record?.landing);
    for (const key of utmKeys) setField(form, key, record?.utm[key]);
    setField(form, 'Attribution status', status);
  }
  function bindForms() {
    for (const form of document.querySelectorAll('form')) {
      if (form.querySelector('input[name="form_type"]')?.value !== 'contact') continue;
      fill(form);
      if (boundForms.has(form)) continue;
      boundForms.add(form);
      form.addEventListener('submit', () => {
        refreshAttribution();
        fill(form);
      }, true);
    }
  }
  function update() {
    refreshAttribution();
    bindForms();
  }
  function start() {
    bindForms();
    if (window.Shopify?.customerPrivacy) update();
    else if (typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) update();
        });
      } catch { bindForms(); }
    }
  }
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
